import { set } from 'cerebral/operators'
import { state, props } from 'cerebral/tags'

export default [
  set(state`selectr.${props`namespace`}.selected.${props`index`}.flash`, false)
]
